import { CompanionService, ApiResponse } from '../types';
import { Companion, CompanionListResponse, CompanionListParams } from '../../model';
import { BaseService } from '../base-service';

export class CompanionServiceReal extends BaseService implements CompanionService {
  constructor() {
    super('CompanionService');
  }

  async getCompanions(params?: CompanionListParams): Promise<ApiResponse<CompanionListResponse>> {
    this.log('getCompanions', params);

    const queryParams = new URLSearchParams();
    if (params?.category) queryParams.append('category', params.category);
    if (params?.search) queryParams.append('search', params.search);
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.per_page) queryParams.append('per_page', params.per_page.toString());

    const endpoint = `/companions${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    return this.makeRequest<CompanionListResponse>(endpoint);
  }

  async getCompanionById(id: string): Promise<ApiResponse<Companion>> {
    this.log('getCompanionById', { id });
    return this.makeRequest<Companion>(`/companions/${id}`);
  }

  async getFeaturedCompanions(): Promise<ApiResponse<Companion[]>> {
    this.log('getFeaturedCompanions');
    return this.makeRequest<Companion[]>('/companions/featured');
  }

  async getRecentlyAdded(): Promise<ApiResponse<Companion[]>> {
    this.log('getRecentlyAdded');
    return this.makeRequest<Companion[]>('/companions/recent');
  }

  async getRecommendedCompanions(userId?: string): Promise<ApiResponse<Companion[]>> {
    this.log('getRecommendedCompanions', { userId });
    const endpoint = userId
      ? `/companions/recommended?userId=${userId}`
      : '/companions/recommended';
    return this.makeRequest<Companion[]>(endpoint);
  }
}
